import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (selected) => ({});

export const tooltip = {
  backgroundColor: (p: any) => p.palette.grey[700],
  color: (p: any) => p.palette.common.white,
  borderRadius: 1,
  maxWidth: 500,
  p: 1,
};
